import styled from 'styled-components'

import { H3 } from 'components/common'
import { Alert } from 'components/common/organisms/alert'
import { COLOR } from 'styles/constants'

export const ListingScheduleTourWrapper = styled.div`
  max-width: 542px;
  padding: 40px 56px;
  overflow: auto;
  max-height: 100vh;
  color: ${COLOR.GREY_LV1};
  background-color: ${COLOR.WHITE};
  position: relative;
  border-radius: 8px;
  @media (max-width: 991px) {
    padding: 24px 28px;
    max-width: 100%;
    height: calc(100% - 50px);
    top: 50px;
    left: 0;
    overflow: auto;
    display: block;
    position: fixed;
    background-color: white;
    z-index: 12;
  }
`

export const CloseButton = styled.i`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 128;
  cursor: pointer;
`

export const ScheduleTourInformationAlert = styled(Alert)`
  & > img {
    filter: invert(17%) sepia(40%) saturate(7024%) hue-rotate(202deg) brightness(93%) contrast(112%);
  }
`

export const ScheduleTourSubTitle = styled(H3)`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  color: ${COLOR.GREY_LV1};
  margin-bottom: 16px;
`
